"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.sourceGroupFragmentDependencies, fragments_1.sourceGroupFragment];
const MUTATION = `
query getSourceGroups {
  sourceGroup {
    ...sourceGroupFragment
  }
}
`.trim();
const getSourceGroupsImpl = (0, notifi_axios_utils_1.makeParameterLessRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'sourceGroup');
exports.default = getSourceGroupsImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0U291cmNlR3JvdXBzSW1wbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2xpYi9xdWVyaWVzL2dldFNvdXJjZUdyb3Vwc0ltcGwudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSw0Q0FHc0I7QUFDdEIsMkVBRzRDO0FBRzVDLE1BQU0sWUFBWSxHQUFHLENBQUMsR0FBRywyQ0FBK0IsRUFBRSwrQkFBbUIsQ0FBQyxDQUFDO0FBRS9FLE1BQU0sUUFBUSxHQUFHOzs7Ozs7Q0FNaEIsQ0FBQyxJQUFJLEVBQUUsQ0FBQztBQUVULE1BQU0sbUJBQW1CLEdBQUcsSUFBQSw2Q0FBd0IsRUFDbEQsSUFBQSx3Q0FBbUIsRUFBQyxHQUFHLFlBQVksRUFBRSxRQUFRLENBQUMsRUFDOUMsYUFBYSxDQUNkLENBQUM7QUFFRixrQkFBZSxtQkFBbUIsQ0FBQyJ9